import { render, staticRenderFns } from "./activitycomment.vue?vue&type=template&id=b7bc798e"
import script from "./activitycomment.vue?vue&type=script&lang=js"
export * from "./activitycomment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports